import { CultureInfo } from '../culture-info.model';
import { CultureInfoHa } from './ha';

/**
 * @ignore
 */
export const CultureInfoHaGH: CultureInfo = {
  name: 'ha-GH',
  displayName: 'Hausa (Gana)',
  iso3LanguageCode: 'hau',
  iso2LanguageCode: 'ha',
  ietfLanguageTag: 'ha-GH',
  parent: CultureInfoHa
};
